import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
interface SignupScreenProps {
  onBack: () => void;
  onContinue: () => void;
}
export function SignupScreen({
  onBack,
  onContinue
}: SignupScreenProps) {
  const [cnic, setCnic] = useState('');
  const handleCnicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/[^\d]/g, '');
    let formatted = digits;
    if (digits.length > 5) {
      formatted = digits.slice(0, 5) + '-' + digits.slice(5);
    }
    if (digits.length > 12) {
      formatted = digits.slice(0, 5) + '-' + digits.slice(5, 12) + '-' + digits.slice(12);
    }
    if (formatted.length <= 15) {
      setCnic(formatted);
    }
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="w-full min-h-screen flex flex-col py-6 px-6" style={{
    backgroundColor: '#FFF5F0'
  }} data-id="element-990">
      {/* Header */}
      <div className="flex items-center justify-between mb-8" data-id="element-991">
        <button onClick={onBack} className="p-2 -ml-2 rounded-full hover:bg-black/5 transition-colors" data-id="element-992">
          <ArrowLeftIcon className="w-6 h-6 text-[#1A1A1A]" strokeWidth={2} data-id="element-993" />
        </button>
        <img src="https://cdn.magicpatterns.com/uploads/k5mzauqmFki77bNt7CFYh1/Whatsapp_digiBOP-removebg-preview.png" alt="digiBOP Logo" className="h-8 w-auto" data-id="element-994" />
        <div className="w-10" data-id="element-995" />
      </div>

      {/* Title */}
      <div className="mb-8" data-id="element-996">
        <h1 className="text-[32px] font-bold text-[#1A1A1A] leading-tight mb-1 tracking-tight" data-id="element-997">
          Let's get started
        </h1>
        <p className="text-[15px] text-[#C85A1A]" data-id="element-998">
          Manage all your finance with ease
        </p>
      </div>

      {/* Form — CNIC Only */}
      <div className="space-y-5 flex-1" data-id="element-999">
        <div data-id="element-1000">
          <label className="block text-xs font-bold text-[#4A3B32] uppercase tracking-wider mb-2 ml-1" data-id="element-1001">
            CNIC Number
          </label>
          <div className="bg-[#FCECE3] rounded-2xl px-5 py-4" data-id="element-1002">
            <input type="text" value={cnic} onChange={handleCnicChange} placeholder="XXXXX-XXXXXXX-X" className="w-full outline-none text-[15px] text-[#4A3B32] bg-transparent placeholder:text-[#A89F98]" data-id="element-1003" />
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-8 pb-4" data-id="element-1004">
        <button onClick={onContinue} disabled={cnic.replace(/\D/g, '').length !== 13} className="w-full bg-gradient-to-r from-[#D95A1A] to-[#B84A12] text-white py-4 rounded-full font-bold text-[15px] tracking-wide shadow-[0_8px_20px_rgba(217,90,26,0.3)] hover:shadow-[0_8px_25px_rgba(217,90,26,0.4)] active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed mb-4" data-id="element-1005">
          CONTINUE
        </button>
      </div>
    </motion.div>;
}